import React from 'react';
import { Modal } from '../../../common/modal';
import PhotoUploadForm from './photo_upload_form';

interface IProps {
    handleClose(): void;
    nhID: number;
    isOpen: boolean;
    propertyName: string;
    propertySlug: string;
}

const PhotoUploadModal = ({
    handleClose,
    nhID,
    isOpen,
    propertyName,
    propertySlug,
}: IProps) => {

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={handleClose}
                title={<>Upload New Photos <span className="text-md text-brand_grey-medium font-medium">(in 2 easy steps)</span></>}
                subTitle={propertyName}
                size='xl'
            >
                <PhotoUploadForm
                    nhID={nhID}
                    propertySlug={propertySlug}
                    handleClose={handleClose}
                />
            </Modal>
        </>
    );
};

export default PhotoUploadModal;